"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// used inside search page tab for long term booking
// add 30 days including pick up date, so total 31 days
var _default = exports["default"] = 30;